export default __webpack_public_path__ + "static/media/DSC_7416.641d126c.jpg";